export const checkVatClassificationFetching = ({ vatClassification: { fetchingData } }) => fetchingData;

export const getVatClassificationData = ({ vatClassification: { data } }) => data;
